import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';
import { IAgent, IAgentFilter, IAgentFilterRequest } from '../models/agents.models';
import { ICatalog, ICatalogFilterRequest } from '../../catalogs/models/catalogs.models';
import { IPageCount } from 'src/app/shared/models/page.model';
import { ICommission, INewCommissionDTO } from '../models/commissions.models';

/**
 * ╔════════════════════════════════════════════════════════════════════╗
 * ║                                                                    ║
 * ║                           Agent Actions                            ║
 * ║                                                                    ║
 * ║   All actions related to agent management in the application.      ║
 * ║   Includes loading, adding, updating, and deleting agents.         ║
 * ║                                                                    ║
 * ╚════════════════════════════════════════════════════════════════════╝
 */

// Get Agents
export const GetAgents = createAction('[ Agents ] - GetAgents',
  props<{filter?: IAgentFilterRequest; key?: string | undefined; subsidiary_id?: number | undefined;}>()
);
export const GetAgentsSuccess = createAction(
  '[ Agents ] - GetAgents Success ',
  props<{ agents: APIResponse<IAgent> }>()
);
export const GetAgentsError = createAction('[ Agents ] - GetAgents Error');

// Get Agent By Id
export const GetAgentById = createAction(
  '[ Agents ] - GetAgentById',
  props<{ id: number, params?: { start_date?: string, end_date?: string } }>()
);
export const GetAgentByIdSuccess = createAction(
  '[ Agents ] - GetAgentById Success ',
  props<{ agent: IAgent }>()
);
export const GetAgentByIdError = createAction(
  '[ Agents ] - GetAgentById Error'
);

// Add Agent
export const AddAgent = createAction(
  '[ Agents ] - AddAgent',
  props<{ agent: Omit<IAgent, 'id'> }>()
);
export const AddAgentSuccess = createAction(
  '[ Agents ] - AddAgent Success ',
  props<{ agent: IAgent }>()
);
export const AddAgentError = createAction('[ Agents ] - AddAgent Error');

// Update Agent
export const UpdateAgent = createAction(
  '[ Agents ] - UpdateAgent',
  props<{ id: number; agent: Partial<IAgent> }>()
);
export const UpdateAgentSuccess = createAction(
  '[ Agents ] - UpdateAgent Success ',
  props<{ agent: IAgent }>()
);
export const UpdateAgentError = createAction('[ Agents ] - UpdateAgent Error');

// Delete Agents
export const DeleteAgents = createAction(
  '[ Agents ] - DeleteAgents',
  props<{ ids: number[] }>()
);
export const DeleteAgentsSuccess = createAction(
  '[ Agents ] - DeleteAgents Success ',
  props<{ ids: number[] }>()
);
export const DeleteAgentsError = createAction(
  '[ Agents ] - DeleteAgents Error'
);

// Loader
export const SetAgentLoader = createAction(
  '[ Agents ] - StartLoading',
  props<{ isLoading: boolean }>()
);

// Get agents Catalogs
export const GetAgentsCatalogs = createAction('[ Agents ] - GetAgentsCatalogs',
  props<{
    page: IPageCount,
    filter?: ICatalogFilterRequest | undefined
    key?: string | undefined
  }>()
);
export const GetAgentsCatalogsSuccess = createAction(
  '[ Agents ] - GetAgentsCatalogs Success ',
  props<{ catalogs: APIResponse<ICatalog> }>()
);
export const GetAgentsCatalogsError = createAction(
  '[ Agents ] - GetAgentsCatalogs Error'
);

export const ClearAgent = createAction('[ Agents ] - ClearAgent');


/**
 * ╔════════════════════════════════════════════════════════════════════╗
 * ║                                                                    ║
 * ║                         Commission Actions                         ║
 * ║                                                                    ║
 * ║   All actions related to commission management in the application. ║
 * ║   Includes loading, adding, updating, and deleting commission.     ║
 * ║                                                                    ║
 * ╚════════════════════════════════════════════════════════════════════╝
 */

// Get Commissions
export const GetCommissions = createAction(
  '[ Commission ] - GetCommissions'
);

export const GetCommissionsSuccess = createAction(
  '[ Commission ] - GetCommissions Success',
  props<{ commissions: APIResponse<ICommission> }>()
);

export const GetCommissionsError = createAction(
  '[ Commission ] - GetCommissions Error'
);

// Get Commission By Id
export const GetCommissionById = createAction(
  '[ Commission ] - GetCommissionById',
  props<{ id: number }>()
);
export const GetCommissionByIdSuccess = createAction(
  '[ Commission ] - GetCommissionById Success ',
  props<{ commission: ICommission }>()
);
export const GetCommissionByIdError = createAction(
  '[ Commission ] - GetCommissionById Error'
);

// Create Commission
export const AddCommission = createAction(
  '[ Commission ] - AddCommission',
  props<{ commission: INewCommissionDTO }>()
);

export const AddCommissionSuccess = createAction(
  '[ Commission ] - AddCommission Success',
  props<{ commission: ICommission }>()
);

export const AddCommissionError = createAction(
  '[ Commission ] - AddCommission Error'
);

// Update Commission
export const UpdateCommission = createAction(
  '[ Commission ] - UpdateCommission',
  props<{ id: number; commission: Partial<INewCommissionDTO> }>()
);
export const UpdateCommissionSuccess = createAction(
  '[ Commission ] - UpdateCommission Success ',
  props<{ commission: ICommission }>()
);
export const UpdateCommissionError = createAction('[ Commission ] - UpdateCommission Error');


// Delete Commissions
export const DeleteCommissions = createAction(
  '[ Commission ] - DeleteCommissions',
  props<{ ids: number[] }>()
);
export const DeleteCommissionsSuccess = createAction(
  '[ Commission ] - DeleteCommissions Success ',
  props<{ ids: number[] }>()
);
export const DeleteCommissionsError = createAction(
  '[ Commission ] - DeleteCommissions Error'
);

export const ClearCommission = createAction('[ Commission ] - ClearCommission');

// Filters
export const SetAgentFilter = createAction(
  '[ Filters ] - SetAgentFilter',
  props<{ keyword: string, advanced: IAgentFilter | null }>()
);

// search
export const SetAgentSearch = createAction(
  '[ Search ] - SetAgentSearch',
  props<{ keyword: string }>()
);

